import { Box, Button, HStack, Link, Text, VStack } from '@chakra-ui/react';
import React, { ReactElement } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { Link as RouterLink } from 'react-router-dom';
import { jobLikes, likeJob } from '~/queries';

import { JobLikeDirection, JobLikes } from '~/generated';

const Likes = (): ReactElement => {
  const { data, refetch } = useQuery<{ jobLikes: JobLikes }>(jobLikes);
  const likes = data?.jobLikes.data || [];
  const [performLike, { error }] = useMutation(likeJob);

  const handleSendLike = async (jobId: string) => {
    await performLike({ variables: { id: jobId } });
    if (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } else {
      void refetch();
    }
  };

  return (
    <VStack
      paddingLeft="20px"
      paddingTop="30px"
      marginBottom="20px"
      alignItems="flex-start"
      width="80%"
    >
      <Box>
        <Text fontWeight="bold">企業から届いた「興味あり」になります。</Text>
        <Text fontWeight="bold">
          こちらも「興味あり」を送ることで、その企業からメッセージが届くようになります。
        </Text>
      </Box>

      <Box minWidth="30%">
        {likes.map((like) => (
          <HStack
            marginBottom="5px"
            borderStyle="solid"
            paddingY="5px"
            paddingRight="5px"
            border="solid lightgray 1px"
            borderRadius="10px"
            justifyContent="space-between"
            key={like.job.id}
          >
            <VStack alignItems="stretch" paddingLeft="10px">
              <Box margin="3px">
                <Link
                  as={RouterLink}
                  to={`/jobs/${like.job.id}`}
                  textDecoration="none"
                  _hover={{ bg: 'lightgray' }}
                  target="_blank"
                >
                  <Text fontWeight="bold">{like.job.title}</Text>
                  <Text>{like.job.company.name}</Text>
                </Link>
              </Box>
            </VStack>
            <Button
              onClick={() => {
                void handleSendLike(like.job.id);
              }}
              disabled={
                like.accepted ||
                like.direction === JobLikeDirection.SeekerToCompany
              }
            >
              {like.accepted ||
              like.direction === JobLikeDirection.SeekerToCompany
                ? '興味あり済み'
                : '興味あり'}
            </Button>
          </HStack>
        ))}
      </Box>
    </VStack>
  );
};

export default Likes;
